window.initBymoqaScroll = function(app){

    const header = app.header;

    let ticking = false;

    function update(){

        const y =
            window.scrollY;

        if(y>80){

            header.classList.add("compact");

        }
        else{

            header.classList.remove("compact");

        }

        ticking=false;

    }

    window.addEventListener("scroll",()=>{

        if(!ticking){

            requestAnimationFrame(update);

            ticking=true;

        }

    });

}